import { render, staticRenderFns } from "./addMemberCoursePackageDialog.vue?vue&type=template&id=23e957a8&scoped=true&"
import script from "./addMemberCoursePackageDialog.vue?vue&type=script&lang=js&"
export * from "./addMemberCoursePackageDialog.vue?vue&type=script&lang=js&"
import style0 from "./addMemberCoursePackageDialog.vue?vue&type=style&index=0&id=23e957a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e957a8",
  null
  
)

export default component.exports